import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";

import {
  Card,
  Col,
  Row,
  Switch,
  Button,
  Badge,
  Avatar,
  Spin,
  Checkbox,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
  Space,
} from "antd";
import {
  CloseOutlined,
  LeftOutlined,
  RadiusBottomleftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Styled from "styled-components";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Line,
} from "recharts";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import ExportIcon from "../../assets/images/Export-Icon.svg";
import { CALL_API } from "../../Common/api";
import UIModal from "../../Reusablecomponents/UIModal";
import { useNavigate } from "react-router-dom";
import {
  ButtonFilled,
  Buttontransparent,
  DashboardButton,
  DashboardNav,
} from "../../Reusablecomponents/UIButtons";
import { CargoWidgets } from "../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import duration from "dayjs/plugin/duration";
import { ReactComponent as LeafMud } from "../../assets/images/mdi_leaf.svg";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
import { color } from "highcharts";
import Dashboard from "./Dashboard";
import { ShipmentType } from "../../Common/constant";

dayjs.extend(duration);

const { Option } = Select;
const { RangePicker } = DatePicker;

const Styledashboard = Styled.div`
.range_picker{
  width: 100% !important;
}
.ant-card .ant-card-head
{padding:10px!important}



.trends-value{
font-size: 12px;
text-align: end;
}
.overview-body{
padding: 16px;
gap: 24px;
backgroundColor:white;
}
img {
  cursor: pointer !important;
}
.addwidget-btn{
  background-color: #E8FFEC;
  color:#2C963D;
  border:none;
}
.ant-card-head{
border-bottom: none;
}
.rechart-legend-icon{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  }
.stats-card{
   display: flex;
  flex-direction: column;
  justify-content: center; 

  height: 100%; 

  }
  .status_card1{
       display: flex;
    justify-content: space-between;;
    padding:3px;
  }

  .presentageValue{
  position:absolute;
  right:15px;
  font-size: 12px;
  
  }
  .ant-switch-checked {
  background-color: #31AB46 !important;
}
.Iconbg{
width:38px;
height:38px;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;
background-color: #EBF7ED;
}

.all-charts-scroll-container {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin; 
}

.cargo-overview{
background : none;
box-shadow : none;
}

.all-charts-scroll-container::-webkit-scrollbar {
  height: 8px; /* Make scrollbar visible */
  background-color: #f1f1f1;
}

.all-charts-scroll-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}
.chart-card {
  width: 100%; 
  max-width: 100%;
  min-width: 300px; 

}

.chart-container {
  width: 100%;
  height: 300px; /* Adjust height as needed */
}

@media (max-width: 425px) {

  .ant-card-head {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px; 
  }

  .ant-card-head-title {
    margin-bottom: 0px;
    font-size: 16px; /* Optional, in case font size is collapsing */

    // display: block; /* Ensures visibility */
  }

  .ant-card-extra {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .trends-value {
    font-size: 12px;
    //     flex-direction: column;
    // justify-content: center;
    // align-items: center;
    text-align: start;
    
  }
      .ant-switch {
      margin-left: 0px;
}

  .overview-body {
    padding: 0px;
    gap: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 0 !important;
       backgroundColor:white;
  }

  .addwidget-btn {
    background-color: #e8ffec;
    color: #2c963d;
    border: none;
    margin-left: 0px;
    margin-bottom: 10px;
  }
}
@media (min-width: 320px) and (max-width: 426px){
  .ant-card-head{
  padding:4px !important;
}
}

`;

const ContainerDashboard = () => {
  const navigate = useNavigate();
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  console.log("VEHILES", AIVehicleLists);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  // const consignmentchart = {
  // data: {
  //   type: 'fetch',
  //   value: 'https://gw.alipayobjects.com/os/antfincdn/iPY8JFnxdb/dodge-padding.json',

  // },
  const [form] = Form.useForm();
  const [cardData, setCardData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isfilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [userWidgets, setUserWidgets] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({
    Duration: "CurrentMonth",
    Daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    consignor: "",
    consignee: "",
    transporter: "",
    deviceid: "",
    tripType: "",
    ShipmentType: "",
  });

  const [trends, setTrends] = useState([]);
  const filteredWidgets = CargoWidgets?.filter((item) =>
    item?.name.toLowerCase()?.includes(searchText.toLowerCase()),
  );
  const [deviceList, setDeviceList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const vehicleOptions = vehicleList.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
  }));
  const deviceOptions = deviceList.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CONT_DASH", "EX"),
    [reduxPermissions],
  );
  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      setDeviceList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllDevice();
    fetchAllVehicle();
  }, []);

  const handleChange = (values) => {
    if (values?.includes("all")) {
      setSelectedWidgets(CargoWidgets?.map((item) => item?.value));
    } else {
      setSelectedWidgets(values);
    }
  };

  const getTrends = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `container/getcontainerTrends`, {
      StartDate:
        dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      EndDate:
        dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),

      Duration: formValues?.Duration || "",
    });

    // const { data } = {
    //   message: "Successfully fetched data.",
    //   data: [
    //     {
    //       Slno: 0,
    //       Description: "Trips",
    //       PreviousValue: 0,
    //       CurrentValue: 147,
    //       PercentageValue: 16.7,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 1,
    //       Description: "Consignments Created vs Delivered",
    //       PreviousValue: 0,
    //       CurrentValue: 1852,
    //       PercentageValue: 8.25,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 2,
    //       Description: "Avg DeliveryTime",
    //       PreviousValue: 0,
    //       CurrentValue: "00:58",
    //       PercentageValue: 27.48,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 3,
    //       Description: "Clients",
    //       PreviousValue: 0,
    //       CurrentValue: 312,
    //       PercentageValue: 72.48,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 4,
    //       Description: "Loading Time",
    //       PreviousValue: 0,
    //       CurrentValue: 70,
    //       PercentageValue: "00.42",
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 5,
    //       Description: "Loading Wait",
    //       PreviousValue: 0,
    //       CurrentValue: "00:24",
    //       PercentageValue: 25.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 6,
    //       Description: "OffLoading Time",
    //       PreviousValue: 0,
    //       CurrentValue: "00:30",
    //       PercentageValue: 30.2,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 7,
    //       Description: "OffLoading wait Time",
    //       PreviousValue: 0,
    //       CurrentValue: "4:00",
    //       PercentageValue: 20,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 8,
    //       Description: "Top Vehicles",
    //       PreviousValue: 898,
    //       CurrentValue: 12,
    //       PercentageValue: 12.2,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 9,
    //       Description: "Fuel per vehicle",
    //       PreviousValue: 0,
    //       CurrentValue: 21295,
    //       PercentageValue: 31.25,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 10,
    //       Description: "Distance per Vehicle",
    //       PreviousValue: 0,
    //       CurrentValue: 235641,
    //       PercentageValue: 34.39,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 11,
    //       Description: "Vehicle Mileage",
    //       PreviousValue: 0,
    //       CurrentValue: 11,
    //       PercentageValue: 20.2,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 12,
    //       Description: "Loading Cycle Times",
    //       PreviousValue: 0,
    //       CurrentValue: "51.82",
    //       PercentageValue: 30.7,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 13,
    //       Description: "OffLoading Cycle Times",
    //       PreviousValue: 0,
    //       CurrentValue: "56:40",
    //       PercentageValue: 50.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 14,
    //       Description: "Time After Loading",
    //       PreviousValue: 0,
    //       CurrentValue: "50:30",
    //       PercentageValue: 70.35,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 15,
    //       Description: "Time After Offloading",
    //       PreviousValue: 0,
    //       CurrentValue: "50:30",
    //       PercentageValue: 20.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 16,
    //       Description: "Carbon Footprint",
    //       PreviousValue: 0,
    //       CurrentValue: 51303,
    //       PercentageValue: 40.4,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 21,
    //       Description: "Delivery Rate",
    //       PreviousValue: 0,
    //       CurrentValue: 116490,
    //       PercentageValue: 20.1,
    //       Colour: "R",
    //     },
    //   ],
    // };
    setTrends(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  const AddRemoveWidgets = async (widget, type) => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `/container/addOrRemoveContWidget`,
      {
        MCID: userInfo?.MCID,
        UID: userInfo?.UID,
        Widgets: widget,
        Type: type,
      },
    );
    getUserWidget();
    setLoading(false);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsFilterModalOpen(false);
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };

  // useEffect(() => {
  //   getFilterCount();
  // }, [formValues]);

  // consignment Chart
  const [loading, setLoading] = useState();
  const [consignmentAndDeliveredData, setConsignmentAndDeliveredData] =
    useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const getConsignmentAndDeliveryt = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        `container/getContainerConsignmentVsDelivery`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          Receiver: formValues?.consignee || 0,
          Shipper: formValues?.transporter || 0,
          // VehId: formValues?.vehicle || "",
          Device: formValues?.deviceid || "",
          Triptype: formValues?.tripType || 0,
          ShipmentType: formValues?.ShipmentType || 0,
          Duration: formValues?.Duration || "",
        },
      );
      setConsignmentAndDeliveredData(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const maxPage = Math.floor(
    consignmentAndDeliveredData?.length / itemsPerPage,
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = Array.isArray(consignmentAndDeliveredData)
    ? consignmentAndDeliveredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage,
      )
    : [];

  useEffect(() => {
    getConsignmentAndDeliveryt();
  }, [formValues]);

  // trip chart
  const [tripPerVehicleData, setTripPerVehicleData] = useState([]);
  const [tripCurrentPage, setTripCurrentPage] = useState(0); // Ensure loading state is declared

  const getTripPerVehicle = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `container/fetchContainerTripPerDevice`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          Receiver: formValues?.consignee || 0,
          Shipper: formValues?.transporter || 0,
          deviceid: formValues?.deviceid || "",
          Triptype: formValues?.tripType || 0,
          ShipmentType: formValues?.ShipmentType || 0,
          Duration: formValues?.Duration || "",
        },
      );
      const selectedVehId = formValues?.deviceid;
      let sorted = [...(data || [])];

      // PRIORITIZE selected vehicle at the top
      if (selectedVehId) {
        sorted.sort((a, b) => {
          if (a.VehId === selectedVehId) return -1;
          if (b.VehId === selectedVehId) return 1;
          return b.value - a.value; // normal descending sort
        });
      }
      setTripPerVehicleData(data || []);
    } catch (error) {
      console.error("Failed to fetch trip per vehicle data", error);
    } finally {
      setLoading(false);
    }
  };

  const tripMaxPage = Math.ceil(tripPerVehicleData.length / itemsPerPage) - 1;

  const tripHandlePrev = () => {
    setTripCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const tripHandleNext = () => {
    setTripCurrentPage((prev) => Math.min(prev + 1, tripMaxPage));
  };

  //  Paginated data for current page
  const tripPaginatedData = tripPerVehicleData.slice(
    tripCurrentPage * itemsPerPage,
    (tripCurrentPage + 1) * itemsPerPage,
  );

  useEffect(() => {
    getTripPerVehicle();
  }, [formValues]);

  //client chart
  const [clientsData, setClientsData] = useState([]);
  const [total, setTotal] = useState(0);
  const [clientCurrentPage, setClientCurrentPage] = useState(0);
  const clientitemsPerPage = 10;

  const getClients = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `container/fetchContainerToptenClient`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          Receiver: formValues?.consignee || 0,
          Shipper: formValues?.transporter || 0,
          Device: formValues?.deviceid || "",
          Triptype: formValues?.tripType || 0,
          ShipmentType: formValues?.ShipmentType || 0,
          Duration: formValues?.Duration || "",
        },
      );

      const parsed =
        data?.map((item) => {
          const valStr = typeof item?.Val === "string" ? item.Val : "";
          const value = parseInt(valStr.split("~")?.[1]) || 0;

          return {
            name: item?.Data,
            value,
          };
        }) || [];

      const totalValue = parsed.reduce((sum, curr) => sum + curr.value, 0);

      setClientsData(parsed);
      setTotal(totalValue);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getClients();
  }, [formValues]);

  const clientMaxPage = Math.ceil(clientsData.length / clientitemsPerPage) - 1;

  const clientHandlePrev = () => {
    setClientCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const clientHandleNext = () => {
    setClientCurrentPage((prev) => Math.min(prev + 1, clientMaxPage));
  };

  const paginatedClients = clientsData.slice(
    clientCurrentPage * clientitemsPerPage,
    (clientCurrentPage + 1) * clientitemsPerPage,
  );

  //vehicle chart

  const [vehicleData, setVehicleData] = useState([]);
  const [vehiclePage, setVehiclePage] = useState(0);
  const vehicleitemsPerPage = 6; // Change based on your desired chunk size

  const getVehiclePerformance = async () => {
    setLoading(true);
    try {
      const response = await CALL_API(
        "POST",
        `container/fetchDistancePerDevice`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          Receiver: formValues?.consignee || 0,
          Shipper: formValues?.transporter || 0,
          Device: formValues?.deviceid || "", // ensure you’re passing this correctly
          Triptype: formValues?.tripType || 0,
          ShipmentType: formValues?.ShipmentType || 0,
        },
      );

      // Map API response to chart data format
      const chartData =
        response?.data?.map((item) => ({
          Data: item?.DeviceName || "N/A",
          Mileage: parseFloat(item?.TotalMileage) || 0,
        })) || [];

      const selectedVehId = formValues?.deviceid;
      let sorted = [...(chartData || [])];

      // PRIORITIZE selected vehicle at the top
      if (selectedVehId) {
        sorted.sort((a, b) => {
          if (a.VehId === selectedVehId) return -1;
          if (b.VehId === selectedVehId) return 1;
          return b.value - a.value; // normal descending sort
        });
      }
      setVehicleData(chartData);
    } catch (err) {
      console.error("Error fetching vehicle performance:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVehiclePerformance();
  }, [formValues]);

  const vehicleMaxPage =
    Math.ceil(vehicleData.length / vehicleitemsPerPage) - 1;

  const handleVehiclePrev = () => {
    setVehiclePage((prev) => Math.max(prev - 1, 0));
  };

  const handleVehicleNext = () => {
    setVehiclePage((prev) => Math.min(prev + 1, vehicleMaxPage));
  };

  const paginatedVehicleData = useMemo(() => {
    return vehicleData.slice(
      vehiclePage * itemsPerPage,
      (vehiclePage + 1) * itemsPerPage,
    );
  }, [vehicleData, vehiclePage]);

  const formattedTime = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0",
      )}`;
    }
  };

  const getColour = (value) => {
    return trends?.find((item, index) => item?.Description === value)?.Colour;
  };

  const getpercentage = (value) => {
    const trendval = trends.find((item) => item.Description === value);
    const percentage = trendval?.PercentageValue;
    return percentage ?? "0%";
  };

  const [liveDistanceData, setLiveDistanceData] = useState([]);
  const getRealTimeDistance = useCallback(async () => {
    try {
      let totalMileage = 0;

      // If vehicle selected → use it
      // Else → use all vehicles
      const selectedFGUID =
        formValues?.vehicle && formValues.vehicle.length > 0
          ? formValues.vehicle
          : AIVehicleLists.map((v) => v.FGUID);

      if (!selectedFGUID) return;

      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/LiveTelematicsDistance",
        {
          FGUID: selectedFGUID,
          StartDate: formValues?.Daterange?.[0]
            ? dayjs(formValues.Daterange[0]).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          EndDate: formValues?.Daterange?.[1]
            ? dayjs(formValues.Daterange[1]).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
        },
      );

      totalMileage = Number(data) || 0;

      setLiveDistanceData(totalMileage);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  }, [formValues, AIVehicleLists]);

  useEffect(() => {
    getRealTimeDistance();
  }, [formValues]);

  //Container Tracking Cards
  const total1 = vehicleList?.length ?? 0;
  const used = cardData?.vehicleUtilization ?? 0;

  const utilizationPercent = total1 ? Math.round((used / total1) * 100) : 0;

  const utilizationValue = `${utilizationPercent}% (${used}/${total1})`;

  const deliveryValue = `${cardData?.deliveryRate ?? 0}%`;
  const cardDatas = useMemo(() => {
    return [
      {
        title: "Trips",
        value: cardData?.totalTrips ?? 0,
        // value: 900,
        subtitle: "Total Trips",
        background: "#FFE2E5",
        percent: getpercentage("Trips"),
        unit: "",
        number: 0,
        color: getColour("Trips"),
      },

      {
        title: "Delivery Time",
        value: formattedTime(cardData?.totalAvgTripTime) ?? "00:00",
        //value: "19:35",
        subtitle: cardData?.totalAvgTripTime >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#F3E8FF",
        number: 1,
        color: getColour("Avg DeliveryTime"),
        percent: getpercentage("Avg DeliveryTime"),
      },
      {
        title: "Loading Time",
        value: formattedTime(cardData?.totalLoadingTime) ?? "00:00",
        //value: "01:09",
        subtitle: cardData?.totalLoadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#FFE2F7",
        number: 2,
        color: getColour("Loading Time"),
        percent: getpercentage("Loading Time"),
      },
      {
        title: "Loading Wait Time",
        value: formattedTime(cardData?.totalLoadingWaitTime) ?? "00:00",
        //value: "01:34",
        subtitle: cardData?.totalLoadingWaitTime >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#EBFFDE",
        number: 3,
        color: getColour("Loading Wait"),
        percent: getpercentage("Loading Wait"),
      },
      {
        title: "Offloading Time",
        value: formattedTime(cardData?.totalOffloadingTime) ?? "00:00",
        //value: "21:00",
        subtitle: cardData?.totalOffloadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#E8EDFF",
        number: 4,
        color: getColour("OffLoading Time"),
        percent: getpercentage("OffLoading Time"),
      },
      {
        title: "Loading Cycle Time",
        value: formattedTime(cardData?.totalLoadingCycle) ?? "00:00",
        //value: "01:34",
        subtitle: cardData?.totalLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#EBFFDE",
        number: 5,
        color: getColour("Loading Wait"),
        percent: getpercentage("Loading Wait"),
      },
      {
        title: "Offloading Cycle Time",
        value: formattedTime(cardData?.totalOffLoadingCycle) ?? "00:00",
        // value: "19:00",
        subtitle: cardData?.totalOffLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#DCF8FC",
        number: 6,
        color: getColour("OffLoading wait Time"),
        percent: getpercentage("OffLoading wait Time"),
      },

      {
        title: "Distance",
        value: cardData?.totalDistance ?? 0,
        // value: "119451",
        subtitle: "KMS",
        background: "#F3E8FF",
        number: 7,
        color: getColour("Distance per Vehicle"),
        percent: getpercentage("Distance per Vehicle"),
      },

      {
        title: "Time After Loading",
        value: formattedTime(cardData?.totalTimeAfterLoading) ?? "00:00",
        // value: "04:02",
        subtitle:
          cardData?.totalTimeAfterLoading >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#E8EDFF",
        number: 8,
        color: getColour("Time After Loading"),
        percent: getpercentage("Time After Loading"),
      },
      {
        title: "Time After Offloading",
        value: formattedTime(cardData?.totalTimeAfterOffloading) ?? "00:00",
        //value: "04:08",
        subtitle:
          cardData?.totalTimeAfterOffloading >= 1440 ? "DD:HH:MM" : "HH:MM",
        background: "#DCF8FC",
        number: 9,
        color: getColour("Time After Offloading"),
        percent: getpercentage("Time After Offloading"),
      },
      {
        title: "Carbon Footprint",
        value: cardData?.totalCarbonFootprint ?? 0,
        // value: "60388.9",
        subtitle: "KgCO2",
        background: " #DDF6E1",
        number: 10,
        leafimg: <LeafMud />,
        color: getColour("Carbon Footprint"),
        percent: getpercentage("Carbon Footprint"),
      },
      {
        title: "Delivery Rate",
        value: deliveryValue,
        // value: "60388.9",
        background: " #FFF4DE",
        number: 17,
        color: getColour("Delivery Rate"),
        percent: getpercentage("Delivery Rate"),
      },
      {
        title: "Vehicle Utilization",
        value: utilizationValue,
        // value: "60388.9",
        background: " #FFE2F7",
        number: 18,
        color: getColour("Vehicle Utilization"),
        percent: getpercentage("Vehicle Utilization"),
      },
      {
        title: "Live Telematics Distance",
        value: liveDistanceData,
        subtitle: "KMS",
        background: " #DCF8FC",
        number: 19,
        color: getColour("Live Telematics Distance"),
        percent: getpercentage("Live Telematics Distance"),
      },
    ];
  }, [cardData, trends]);
  const mergedCardDatas = cardDatas.map((card) => {
    const matchingTrend = trends.find((trend) => trend.Slno === card.number);

    return {
      ...card,
      percent: matchingTrend ? `${matchingTrend.PercentageValue}%` : "",
      colour: matchingTrend?.Colour?.trim() || "",
    };
  });

  const Duration = [
    { label: "Current Month", value: "CurrentMonth" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const getUserWidget = async () => {
    const { data } = await CALL_API("POST", `/container/fetchContUserWidgets`, {
      mcId: userInfo?.MCID,
      userId: userInfo?.UID,
    });

    const widgets = data?.[0]?.CONTAINERWIDGETS;
    setUserWidgets(
      widgets ? widgets.split(",").map(Number) : [], // fallback to []
    );
  };

  const getCardData = async () => {
    const { data } = await CALL_API("POST", `container/getContainerDashData`, {
      mcId: userInfo?.MCID,
      StartDate:
        dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      EndDate:
        dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      Cust: formValues?.consignor || 0,
      Receiver: formValues?.consignee || 0,
      Shipper: formValues?.transporter || 0,
      Device: formValues?.deviceid || 0,
      Triptype: formValues?.tripType || 0,
      driver: formValues?.driver || 0,
      Duration: formValues?.Duration || "",
      ShipmentType: formValues?.ShipmentType || 0,
    });
    setCardData(data);
  };

  // useEffect(() => {
  //   getRealTimeDistance();
  // },[])

  useEffect(() => {
    getUserWidget();
    getCardData();
  }, [formValues]);

  const [cardOrder, setCardOrder] = useState(
    cardDatas.map((card) => card.number),
  );

  const [dragIndex, setDragIndex] = useState(null);

  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    const newOrder = [...cardOrder];
    const draggedItem = newOrder[dragIndex];

    newOrder.splice(dragIndex, 1);
    newOrder.splice(dropIndex, 0, draggedItem);
    setCardOrder(newOrder);
    setDragIndex(null);
  };

  useEffect(() => {
    setSelectedWidgets(userWidgets?.map((item) => item));
  }, [userWidgets]);
   useEffect(() => {
      const duration = formValues?.Duration;
      let range = [null, null];
  
      if (duration === "last_month") {
        range = [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ];
      } else if (duration === "CurrentMonth") {
        range = [dayjs().startOf("month"), dayjs().endOf("month")];
      } else if (duration === "current_year") {
        range = [dayjs().startOf("year"), dayjs().endOf("year")];
      } else if (duration === "today") {
        range = [dayjs(), dayjs()];
      } else if (duration === "---") {
        range = [null, null];
      }
  
      form.setFieldsValue({
        Daterange: range,
      });
  
      setFormValues((prev) => ({
        ...prev,
        Daterange: range,
      }));
    }, [formValues?.Duration]);

  const ConsigndeliveryChart = ({ data }) => {
    return (
      <Spin spinning={loading}>
        <ResponsiveContainer
          width="95%"
          height={325}
          id="consignment and delivered"
        >
          <BarChart
            data={data}
            margin={{
              top: 10,
              right: 0,
              left: 0,
              bottom: 5,
            }}
            barCategoryGap="0%"
            barGap={0}
            // barSize={14}
          >
            <Legend
              layout="horizontal"
              align="center"
              verticalAlign="top"
              wrapperStyle={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                borderRadius: "5px",
              }}
            />
            <CartesianGrid stroke="none" />
            <XAxis
              dataKey="Data"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10.5, fill: "#666" }}
            />

            <YAxis axisLine={false} tickLine={false} />
            <Tooltip />
            <Bar
              dataKey="Consignments"
              name="Consignments"
              fill="#E4A400"
              radius={[4, 4, 0, 0]}
              barSize={35}
            />
            <Bar
              dataKey="Delivered"
              name="Delivered"
              fill="#00BC13"
              radius={[4, 4, 0, 0]}
              barSize={35}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const TripPerVehicleChart = ({ data }) => {
    return (
      <Spin spinning={loading}>
        <ResponsiveContainer width="100%" height={380} id="Trip Per Vehicle">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
            barSize={28}
            cursor="pointer"
            barCategoryGap="2%" // Reduced gap between bar categories (groups)
            barGap={1}
          >
            <CartesianGrid vertical={false} horizontal={true} />
            <XAxis
              dataKey="Devices"
              tickLine={false}
              interval={0}
              tick={{ fontSize: 11, fill: "#666" }}
            />
            <YAxis tickLine={false} />
            <Tooltip />
            {/* <Legend /> */}
            <Bar
              dataKey="Trips"
              name="Trips"
              fill="#0E9CD4"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const COLORS = [
    "#7DFF8A",
    "#8175FF",
    "#0065BC",
    "#00EA98",
    "#00D2F2",
    "#007EEA",
    "#FF8664",
    "#FFE478",
    "#FF5BB2",
    "#C859FF",
  ];

  const isMobile = window.innerWidth < 600; // Detect mobile screen

  // <Pie
  //   label={!isMobile ? renderCustomizedLabel : null} // Hide labels on mobile
  // />
  const TopClientsChart = ({ data, total }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < 768); // adjust breakpoint as needed
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const renderCustomizedLabel = ({
      cx,
      cy,
      midAngle,
      innerRadius,
      percent,
      outerRadius,
      index,
    }) => {
      // ✅ hide outside lines and text completely on mobile
      if (isMobile) return null;

      const RADIAN = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 1.23;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
      const ishrline = Math.cos(-midAngle * RADIAN) > 0;
      const lineLength = ishrline ? 80 : -80;
      const textOffset = ishrline ? 20 : -20;
      const color = COLORS[index % COLORS.length];
      const squareSize = 12;

      return (
        <>
          {/* Connector line */}
          <line
            x1={x}
            y1={y}
            x2={x + lineLength}
            y2={y}
            stroke="#BEBEBE"
            strokeWidth={1}
          />
          <rect
            x={x + lineLength + (ishrline ? -squareSize : 0)}
            y={y - squareSize / 2}
            width={squareSize}
            height={squareSize}
            fill={color}
          />
          <text
            x={x + lineLength + textOffset}
            y={y}
            fill="#5F6D8C"
            textAnchor={ishrline ? "start" : "end"}
            dominantBaseline="central"
            fontSize={14}
          >
            {`${clientsData[index].name} (${(percent * 100).toFixed(2)}%)`}
          </text>
        </>
      );
    };

    return (
      <Row>
        <Col xs={0} lg={2} xl={2}></Col>

        {/* Pie Chart */}
        <Col xs={24} lg={24} xl={24} style={{ order: 1, marginBottom: 16 }}>
          <Spin spinning={loading}>
            <ResponsiveContainer width="100%" height={500} id="Clients">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius="40%"
                  outerRadius="76%"
                  fill="#8884d8"
                  cursor="pointer"
                  label={renderCustomizedLabel}
                  labelLine={!isMobile} // ✅ hides built-in lines on mobile
                  dataKey="value"
                >
                  {clientsData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>

                {/* Total in center */}
                <text
                  x="50%"
                  y="47%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={22}
                  fontWeight="bold"
                >
                  {total}
                </text>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={18}
                  fontWeight="bold"
                >
                  Trips
                </text>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </Spin>
        </Col>

        {/* ✅ Show legend/data labels only on mobile */}
        {isMobile && (
          <Col xs={24} lg={24} xl={24} style={{ order: 2 }}>
            <div>
              {clientsData.map((client, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{
                      width: 12,
                      height: 12,
                      backgroundColor: COLORS[index % COLORS.length],
                      marginRight: 8,
                    }}
                  />
                  <span style={{ color: "#5F6D8C", fontSize: 14 }}>
                    {client.name}: {client.value}
                  </span>
                </div>
              ))}
            </div>
          </Col>
        )}

        <Col xs={0} lg={2} xl={2}></Col>
      </Row>
    );
  };

  const VehiclePerformanceChart = ({ data }) => {
    return (
      <Spin spinning={loading}>
        <ResponsiveContainer width="100%" height={325} id="Vehicle Performance">
          <ComposedChart
            data={data}
            margin={{ top: 40, right: 30, left: 20, bottom: 5 }}
            barCategoryGap="25%"
            barGap={0}
            style={{ cursor: "pointer" }}
          >
            <Legend
              layout="horizontal"
              align="center"
              verticalAlign="top"
              wrapperStyle={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                borderRadius: "5px",
              }}
            />
            <CartesianGrid vertical={false} horizontal={true} />
            <XAxis
              dataKey="Data"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: "#666" }}
            />
            <YAxis axisLine={false} tickLine={false} />
            <Tooltip />
            <Bar
              dataKey="Mileage"
              name="Distance (Km)"
              fill="#FF73DB"
              radius={[4, 4, 0, 0]}
              barSize={16}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const [isSwitchChecked, setIsSwitchChecked] = useState(false);

  const onChange = (checked) => {
    setIsSwitchChecked(checked);
    getTrends();
  };

  return (
    <>
      <div>
        <DashboardNav></DashboardNav>
      </div>
      <div style={{ backgroundColor: "white" }} className="dashboard-content">
        <Styledashboard>
          <div
            style={{
              backgroundColor: "white",
            }}
            className="overview-body"
          >
            <Card
              style={{
                border: "none",
                borderTopLeftRadius: isMobile ? "0px" : "8px",
                borderTopRightRadius: isMobile ? "0px" : "8px",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
                marginBottom: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  flexWrap: "nowrap", // keeps in one row
                  width: "100%",

                  paddingBottom: "4px",
                }}
              >
                {/* Left side: Trends + Switch */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexShrink: 0,
                  }}
                >
                  <span
                    className="trends-value"
                    style={{
                      color: "#5F6D8C",
                      fontSize: "18px",
                      whiteSpace: "nowrap",
                    }}
                    ws
                  >
                    Trends
                  </span>
                  <Switch onChange={onChange} color="#31AB46" />
                </div>

                {/* Right side: Add Widget + Filter */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexShrink: 0,
                  }}
                >
                   <div className="dropstyle">
                      <Select
                        placeholder="Custom Range"
                        value={formValues?.Duration}
                        onChange={(value) =>
                          setFormValues((prev) => ({
                            ...prev,
                            Duration: value,
                          }))
                        }
                      >
                        {Duration.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div className="dropstyle1">
                      <Space direction="vertical" size={12}>
                        <RangePicker
                          value={formValues?.Daterange}
                          onChange={(value) =>
                            setFormValues((prev) => ({
                              ...prev,
                              Daterange: value,
                            }))
                          }
                        />
                      </Space>
                    </div>
                  <ButtonFilled
                    className="addwidget-btn"
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                  >
                    + Add Widget
                  </ButtonFilled>
                  <div className="Iconbg" style={{ cursor: "pointer" }}>
                    <img
                      src={FilterIcon}
                      alt="Filter Icon"
                      width={20}
                      height={20}
                      style={{ display: "block" }}
                      onClick={() => setIsFilterModalOpen(true)}
                    />
                  </div>
                </div>
              </div>
              <Spin spinning={loading}>
                <Row gutter={[16, 16]}>
                  {cardOrder
                    .filter((num) => selectedWidgets.includes(num))
                    .map((num) => cardDatas.find((card) => card.number === num))
                    .map((item, index) => (
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        key={item.number}
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(index)}
                        style={{ cursor: "grab" }}
                      >
                        <Card
                          title={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "8px",
                                width: "100%",
                                overflow: "hidden",
                                paddingBottom: "6px",
                              }}
                            >
                              <span
                                style={
                                  window.innerWidth >= 320 &&
                                  window.innerWidth <= 426
                                    ? {
                                        fontSize: "13px",
                                        padding: "4px",
                                        textWrap: "wrap",
                                      }
                                    : {
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        lineHeight: 1.3,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        minWidth: 0,
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                      }
                                }
                                className="card-title-text"
                                title={item.title}
                              >
                                {item.title}
                                {item.leafimg && (
                                  <span style={{ marginLeft: "6px" }}>
                                    {item.leafimg}
                                  </span>
                                )}
                              </span>

                              <div style={{ flexShrink: 0 }}>
                                <CloseOutlined
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    AddRemoveWidgets(`${item.number}`, 0)
                                  }
                                />
                              </div>
                            </div>
                          }
                          bordered={false}
                          style={{
                            backgroundColor: item.background,
                            textAlign: "left",
                            overflow: "hidden",
                            wordBreak: "break-word",
                            height: "100%", // ✅ Full block height (matches siblings)
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                          bodyStyle={{
                            paddingTop: 0,
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "left",
                              overflow: "hidden",
                              flexGrow: 1,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              className="stats-card"
                              style={{
                                textAlign: "left",
                                overflow: "hidden",
                              }}
                            >
                              <h4
                                style={
                                  window.innerWidth >= 320 &&
                                  window.innerWidth <= 426
                                    ? {
                                        fontSize: "17px",
                                        padding: "4px",
                                        textWrap: "wrap",
                                      }
                                    : {
                                        margin: 0,
                                        textAlign: "left",
                                      }
                                }
                                title={item.value}
                              >
                                {item.value}
                              </h4>
                              <p
                                style={
                                  window.innerWidth >= 320 &&
                                  window.innerWidth <= 426
                                    ? {
                                        fontSize: "14px",
                                        padding: "4px",
                                        textWrap: "wrap",
                                      }
                                    : {
                                        margin: "4px 0",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }
                                }
                                title={item.subtitle}
                              >
                                {item.subtitle}
                              </p>
                            </div>

                            {isSwitchChecked && (
                              <div
                                className="status_card1"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: "6px",
                                  overflow: "hidden",
                                }}
                              >
                                {item.color && (
                                  <p
                                    className={
                                      item.color === "G"
                                        ? "text-success"
                                        : item.color === "R"
                                          ? "text-danger"
                                          : ""
                                    }
                                    style={{
                                      margin: 0,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    ({item.percent}%)
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </Spin>
            </Card>
          </div>
          <div
            style={{ marginTop: "20px" }}
            className="all-charts-scroll-container"
          >
            {/* {[1].some((id) => selectedWidgets?.includes(id)) && ( */}
            <Card
              className="chart-card"
              bordered={false}
              id="consignment and delivered"
              title={null} // hide AntD's default title layout
              style={{
                overflowX: "auto",
              }}
            >
              {/* Custom Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "nowrap",
                  gap: "8px",
                  padding: "0 8px 8px 8px",
                }}
              >
                {/* Title */}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#000",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1, // ensures title always visible and pushes icons to right
                  }}
                  title="Total Consignment & Delivered"
                >
                  Total Consignment & Delivered
                </span>

                {/* Icons */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    flexShrink: 0,
                  }}
                >
                  <LeftOutlined
                    onClick={handlePrev}
                    style={{
                      cursor: currentPage === 0 ? "not-allowed" : "pointer",
                    }}
                  />
                  <RightOutlined
                    onClick={handleNext}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                  <div className="Iconbg">
                    <img
                      title="Export Icon"
                      src={ExportIcon}
                      alt="Export Icon"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "consignment and delivered",
                          "consignment and delivered",
                        );
                      }}
                    />
                  </div>

                  <CloseOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => AddRemoveWidgets("1", 0)}
                  />
                </div>
              </div>

              {/* Chart Content */}
              <ConsigndeliveryChart data={paginatedData} />
            </Card>

            {/* // )} */}
          </div>

          <div className="all-charts-scroll-container">
            {[8].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Trip Per Device"
                style={{ overflowX: "auto" }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title with ellipsis */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // ensures icons stay at right
                    }}
                    title="Trips Per Device"
                  >
                    Trips Per Device
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "15px",
                      flexShrink: 0, // prevents icons from shrinking
                    }}
                  >
                    <LeftOutlined
                      onClick={tripHandlePrev}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <RightOutlined
                      onClick={tripHandleNext}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Trip Per Device",
                            "Trip Per Device",
                          );
                        }}
                      />
                    </div>

                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("8", 0)}
                    />
                  </div>
                </div>

                {/* Chart Content */}
                <TripPerVehicleChart data={tripPaginatedData} />
              </Card>
            )}
          </div>

          <div className="all-charts-scroll-container">
            {[3].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Clients"
                style={{
                  overflowX: "auto",
                }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // pushes icons to right and keeps title visible
                    }}
                    title="Top 10 Clients"
                  >
                    Top 10 Clients
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      flexShrink: 0,
                    }}
                  >
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart("Clients", "Clients");
                        }}
                      />
                    </div>

                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("3", 0)}
                    />
                  </div>
                </div>

                {/* Chart Content */}
                <TopClientsChart
                  className="donut-chart"
                  totel={total}
                  data={paginatedClients}
                />
              </Card>
            )}
          </div>

          <div className="all-charts-scroll-container">
            {[9, 10, 11].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Vehicle Performance"
                style={{ overflowX: "auto" }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title with ellipsis */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // ✅ pushes icons to the right
                    }}
                    title="Distance Per Device"
                  >
                    Distance Per Device
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "15px",
                      flexShrink: 0, // ensures icons never shrink or wrap
                    }}
                  >
                    <LeftOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehiclePrev}
                    />
                    <RightOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehicleNext}
                    />
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Vehicle Performance",
                            "Vehicle Performance",
                          );
                        }}
                      />
                    </div>

                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("9,10,11", 0)}
                    />
                  </div>
                </div>

                {/* Chart Content */}
                <VehiclePerformanceChart data={paginatedVehicleData} />
              </Card>
            )}
          </div>
        </Styledashboard>
      </div>

      <UIModal
        header="Add Widgets"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              onClick={() => {
                setIsModalOpen(false);
                getUserWidget();
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              className="w-50 px-3"
              loading={loading}
              onClick={() =>
                AddRemoveWidgets(
                  selectedWidgets?.map((item) => item).join(","),
                  1,
                )
              }
            >
              Add Widgets
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div>
          <Select
            mode="multiple"
            value={selectedWidgets}
            onChange={handleChange}
            placeholder="Select"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            dropdownRender={(menu) => (
              <>
                <div style={{ padding: "5px" }}>
                  <Checkbox
                    checked={selectedWidgets?.length === CargoWidgets.length}
                    onChange={(e) =>
                      handleChange(e.target.checked ? ["all"] : [])
                    }
                  >
                    Select All
                  </Checkbox>
                </div>
                <div style={{ padding: "5px" }}>
                  <Input
                    placeholder="Search"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                {menu}
              </>
            )}
          >
            {filteredWidgets.map((role) => (
              <Option key={role?.value} value={role?.value}>
                <Checkbox checked={selectedWidgets?.includes(role?.value)}>
                  {role?.name}
                </Checkbox>
              </Option>
            ))}
          </Select>
        </div>
      </UIModal>
      <Modal
        open={isfilterModalOpen}
        onCancel={handleCancel}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
               const resetValues = {
                  Duration: "CurrentMonth",
                  deviceid: undefined,
                  consignor: undefined,
                  transporter: undefined,
                  consignee: undefined,
                  tripType: undefined,
                  ShipmentType: undefined,
                };

                form.resetFields();
                form.setFieldsValue(resetValues);
                setFormValues(resetValues);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Styledashboard>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              getFilterCount();
              setFormValues({...formValues,...allvalues});
            }}
            initialValues={formValues}
          >
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Device Name" name="deviceid">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={deviceOptions}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignee" name="consignee">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consigneeList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={12} sm={12} md={6}>
                <Form.Item label="Duration" name="Duration">
                  <Select>
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Date Range" name="Daterange">
                  <RangePicker
                    className="range_picker"
                    defaultPickerValue={[dayjs(), dayjs()]}
                    value={null}
                    allowClear
                  />
                </Form.Item>
              </Col> */}

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Trip Type" name="tripType">
                  <Select className="w-100" showSearch allowClear>
                    <Option value={2}>Safari</Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Shipment Type" name="ShipmentType">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={ShipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Styledashboard>
      </Modal>
    </>
  );
};

export default ContainerDashboard;
